import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { userActions } from '_actions';
import styles from './LoginPage.module.css'
import { MsalContext } from "@azure/msal-react";
import { loginRequest } from "../authConfig";
import { history } from '_helpers';
import { RouteDefs } from '_constants';
import { callMsGraph } from '_services';
import { InteractionStatus } from "@azure/msal-browser";
import { CompanySelectionPanel } from './CompanySelectionPanel';

class AutoLoginPage extends React.Component {
    static contextType = MsalContext;

    constructor(props) {
        super(props);

        this.state = {
            userId: undefined,
            loggingIn: false
        };
    }


    callLogin() {
        var isAuthenticated = this.context.accounts.length > 0;

        if (!isAuthenticated) { // we aren't authenticated to AAD yet
            if (this.context.inProgress === InteractionStatus.None) { // if the context is done intializing and not currently processing
                this.context.instance.loginRedirect(loginRequest) // call AAD to authenticate
                    .catch(e => {
                        console.log(e);
                        history.push(RouteDefs.loginPage.path);
                    });

            }
        } else { // we are authenticated to AAD
            if (!localStorage.getItem('user')) { // we haven't logged into the EMR yet
                if (!this.state.loggingIn) { // we aren't currently attempting login
                    this.setState({ loggingIn: true });
                    this.emrLogin();
                }
            } else { // user is logged into EMR
                if (this.props.selectedCompany) { // AND they have a selected company
                    history.push(RouteDefs.therapistDashboard.path);
                } else if (!this.props.availableCompanies) {
                    history.push(RouteDefs.loginPage.path);
                }
            }
        }
    }

    componentDidMount() {
        this.callLogin();
    }

    componentDidUpdate() {
        this.callLogin();
    }



    emrLogin() {
        // Silently acquires an access token which is then attached to a request for MS Graph data
        this.context.instance
            .acquireTokenSilent({
                ...loginRequest,
                account: this.context.accounts[0],
            })
            .then((response) => {
                callMsGraph(response.accessToken)
                    .then((response) => {
                        let uid;

                        if (response.userPrincipalName) {
                            uid = response.userPrincipalName.substr(
                                0,
                                response.userPrincipalName.indexOf("@")
                            );
                        } else {
                            uid = response.mail.substr(0, response.mail.indexOf("@"));
                        }

                        this.setState({ userId: uid });
                        this.props.login(uid)

                    })
                    .catch((err) => {
                        history.push(RouteDefs.loginPage.path);
                    });
            })
            .catch((err) => {
                history.push(RouteDefs.loginPage.path);
            });
    }


    render() {
        return (
            <div className={styles.login_wrapper}>
                <img alt='CORA Physical Therapy' className={styles.logo} src='./images/cora_animated.gif'></img>
                {this.props.availableCompanies && this.props.availableCompanies.length > 1 &&
                    <CompanySelectionPanel />
                }
                {(!this.props.availableCompanies || this.props.availableCompanies.length === 1) &&
                    <p>Loading...</p>
                }
                {this.props.availableCompanies && this.props.availableCompanies.length === 0 &&
                    <p>No therapist profile identified.  Please contact the help desk.</p>
                }
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        availableCompanies: state.entities.authentication.user ? state.entities.authentication.user.availableCompanies : {},
        selectedCompany: state.entities.authentication.user ? state.entities.authentication.user.company : undefined
    };
}

function mapDispatchToProps(dispatch) {
    return {
        login: bindActionCreators(userActions.login, dispatch),
    };
}

const connectedAutoLoginPage = connect(mapStateToProps, mapDispatchToProps)(AutoLoginPage);
export { connectedAutoLoginPage as AutoLoginPage }; 